<template>
  <div>
    <a-layout>
      <a-layout-header class="header">
        <a-row type="flex">
          <a-col flex="370px">
            <div class="title">
              <img class="logo" src="/image/logo.png"/>
              <div class="text">广州市番禺水务股份有限公司网上营业厅</div>
            </div>
          </a-col>
          <a-col flex="auto">
            <a-menu
                @click="menuOnClick"
                mode="horizontal"
            >
              <a-menu-item v-for="(item,index) in menu" :key="index">
                <template #icon>
                  <icon-font :type="item.icon" class="menu-icon"/>
                </template>
                {{ item.title }}
              </a-menu-item>
            </a-menu>
          </a-col>
          <a-col flex="100px">
            <a-button type="text" @click="userNameOnClick">
              <template #icon>
                <UserOutlined/>
              </template>
              {{ userName }}
            </a-button>
          </a-col>
        </a-row>
      </a-layout-header>
    </a-layout>
    <a-layout-content class="content">
      <router-view></router-view>
    </a-layout-content>
    <a-layout-footer class="footer">
      版权所有 © 2022 广州市番禺水务股份有限公司 粤ICP备18113752号
    </a-layout-footer>
  </div>
</template>

<script setup>
import {ref, watchEffect} from "vue"
import router from '@/router/index'
import store from '@/store/index'
import {UserOutlined} from '@ant-design/icons-vue';
import {Modal, notification} from 'ant-design-vue';
import {IconFont} from '@/iconfont/iconfont'
import menu from "./menu";

// 导航栏点击事件
const menuOnClick = (item) => {

  router.push({
    path: menu[item.key].path
  })
}

// 导航栏用户信息
const userName = ref('点击登录');

watchEffect(() => {
  userName.value = store.state.accountInfo == null ? '点击登录' : store.state.accountInfo.phoneNumber + ' | 退出登录';
})

// 导航栏用户信息点击事件
const userNameOnClick = () => {
  if (store.state.accountInfo == null) {
    router.push('/user/login');
  } else {
    Modal.confirm({
      title: '是否确认退出登录?',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        store.commit('setAccountInfo', null);
        notification.success({
          duration: 8,
          placement: 'bottomRight',
          message: '退出登录成功',
          description:
              '感谢使用网上营业厅，如有疑问可致电我司全区统一客服热线：020-84819666',
        });
        router.push('/index');
      },
    })
  }
}

</script>

<style scoped lang="less">
@import 'BasicLayout.less';
</style>